/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingAttendance
 */
export interface TrainingAttendance {
    /**
     * 
     * @type {string}
     * @memberof TrainingAttendance
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingAttendance
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingAttendance
     */
    playerId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingAttendance
     */
    playerName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingAttendance
     */
    present?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingAttendance
     */
    late?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingAttendance
     */
    expectedBaseAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingAttendance
     */
    expectedExtraAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingAttendance
     */
    expectedAmount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingAttendance
     */
    basePaid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingAttendance
     */
    baseAmountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingAttendance
     */
    extraPaid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingAttendance
     */
    extraAmountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingAttendance
     */
    paid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingAttendance
     */
    amountPaid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingAttendance
     */
    comment?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingAttendance
     */
    markedAt?: Date;
}

/**
 * Check if a given object implements the TrainingAttendance interface.
 */
export function instanceOfTrainingAttendance(value: object): value is TrainingAttendance {
    return true;
}

export function TrainingAttendanceFromJSON(json: any): TrainingAttendance {
    return TrainingAttendanceFromJSONTyped(json, false);
}

export function TrainingAttendanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingAttendance {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'present': json['present'] == null ? undefined : json['present'],
        'late': json['late'] == null ? undefined : json['late'],
        'expectedBaseAmount': json['expectedBaseAmount'] == null ? undefined : json['expectedBaseAmount'],
        'expectedExtraAmount': json['expectedExtraAmount'] == null ? undefined : json['expectedExtraAmount'],
        'expectedAmount': json['expectedAmount'] == null ? undefined : json['expectedAmount'],
        'basePaid': json['basePaid'] == null ? undefined : json['basePaid'],
        'baseAmountPaid': json['baseAmountPaid'] == null ? undefined : json['baseAmountPaid'],
        'extraPaid': json['extraPaid'] == null ? undefined : json['extraPaid'],
        'extraAmountPaid': json['extraAmountPaid'] == null ? undefined : json['extraAmountPaid'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'markedAt': json['markedAt'] == null ? undefined : (new Date(json['markedAt'])),
    };
}

export function TrainingAttendanceToJSON(json: any): TrainingAttendance {
    return TrainingAttendanceToJSONTyped(json, false);
}

export function TrainingAttendanceToJSONTyped(value?: TrainingAttendance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sessionId': value['sessionId'],
        'playerId': value['playerId'],
        'playerName': value['playerName'],
        'present': value['present'],
        'late': value['late'],
        'expectedBaseAmount': value['expectedBaseAmount'],
        'expectedExtraAmount': value['expectedExtraAmount'],
        'expectedAmount': value['expectedAmount'],
        'basePaid': value['basePaid'],
        'baseAmountPaid': value['baseAmountPaid'],
        'extraPaid': value['extraPaid'],
        'extraAmountPaid': value['extraAmountPaid'],
        'paid': value['paid'],
        'amountPaid': value['amountPaid'],
        'comment': value['comment'],
        'markedAt': value['markedAt'] == null ? value['markedAt'] : value['markedAt'].toISOString(),
    };
}

